// extracted by mini-css-extract-plugin
export default {"PageLayout":"settings-view-module__PageLayout--XCYfZ","Pane":"settings-view-module__Pane--zgPcC","Content":"settings-view-module__Content--gnJgH"};